import { WORKOUT_KEY } from '../../../../modules/workout/model/constants/key'
import { caloriesWorkoutValidatorUtil } from '../../../../modules/workout/model/validators/calories'

const workoutValidator = {
  [WORKOUT_KEY.CALORIES]: caloriesWorkoutValidatorUtil
}

export default workoutValidator
